import React from 'react';
import { Bell } from 'lucide-react';
import TicketCard from '../ui/TicketCard';

// NEW: Bell — W6: auf allen Routen sichtbar (F5). #562: aus Header.js gelöst;
// rendert nur, Zustand und Handler hält der Header. Stile in kopfzeile.css.
const Glocke = ({
  t, isMobile, bellRef, handleBellClick, bellAttention, displayedUnreadCount, showBellDropdown,
  loadingDebugItems, notificationActivationPending, attentionTickets, requestDesktopNotifications,
  notificationPermission, handleOpenTicketDetailModal
}) => (
  <div className="kopf-ankerpunkt" ref={bellRef}>
    <button
      onClick={handleBellClick}
      title={bellAttention ? t('header.unreadTitle', `${displayedUnreadCount} ungelesene Tickets/Aktivitäten`, { count: displayedUnreadCount }) : t('header.notifications', 'Benachrichtigungen')}
      className="kopf-knopf kopf-knopf--hover kopf-glocke-knopf"
    >
      <Bell size={18} />
      {bellAttention && (
        <span className="kopf-zaehler">
          {Math.min(displayedUnreadCount || 0, 99)}
        </span>
      )}
    </button>
    {showBellDropdown && (
      <div className={`kopf-dropdown kopf-dropdown--glocke${isMobile ? ' kopf-dropdown--mobil' : ''}`}>
        {loadingDebugItems && loadingDebugItems.length > 0 && (
          <div className="kopf-ladestatus">
            <div className="kopf-ladestatus-kopf">
              <strong>{t('header.loadingStatus', 'Lade-Status')}</strong>
              <span className="kopf-zahl">{loadingDebugItems.length}</span>
            </div>
            <div className="kopf-ladestatus-liste">
              {loadingDebugItems.map((it) => (
                <div key={it.id} className="kopf-ladestatus-eintrag">
                  <span>{it.status === 'ok' ? '✅' : (it.status === 'error' ? '⚠️' : '⏳')}</span>
                  <span className="kopf-ladestatus-text">{it.label}</span>
                  <span className={`kopf-ladestatus-quelle${it.source === 'o365' ? ' kopf-ladestatus-quelle--o365' : ''}`}>
                    {it.source === 'o365' ? 'O365' : 'Local-DB'}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}
        <div className="kopf-abschnitt-kopf">
          <strong>{t('header.activities', 'Aktivitäten')}</strong>
          <span className="kopf-zahl">{displayedUnreadCount}</span>
        </div>
        {(() => {
          const hasAny = notificationActivationPending || (attentionTickets.length > 0);
          if (!hasAny) {
            return <div className="kopf-leer">{t('header.noNewActivities', 'Keine neuen Aktivitäten')}</div>;
          }
          return (
            <div className="kopf-glocke-liste">
              {notificationActivationPending && (
                <div className="kopf-glocke-aktivieren">
                  <button
                    onClick={requestDesktopNotifications}
                    className="btn btn-secondary kopf-breit"
                    title={notificationPermission === 'denied' ? t('header.notificationsBlocked', 'Benachrichtigungen im Browser erlaubt? (aktuell blockiert)') : t('header.enableNotifications', 'Desktop-Benachrichtigungen aktivieren')}
                  >
                    {t('header.enableNotificationsShort', 'Benachrichtigungen aktivieren')}
                  </button>
                </div>
              )}
              {/* #138 (W7): gemeinsame TicketCard auch in der Glocke;
                  Kopfzeile = #Nr + Aktivitätstyp (#126), Fußzeile = Zuweisung */}
              {attentionTickets.map((tkt) => (
                <TicketCard
                  key={tkt.id}
                  ticket={{ ...tkt, title: tkt.title || t('ticketDetail.ticket', 'Ticket') }}
                  hasNew={false}
                  onClick={() => handleOpenTicketDetailModal(tkt.id)}
                  headerRow={(
                    <div className="kopf-ticket-kopf">
                      <span className="ticket-number">#{tkt.ticketNumber || tkt.id}</span>
                      {tkt.activityType && (
                        <span className="kopf-ticket-art">
                          {tkt.activityType === 'newTicket' ? t('header.activityNewTicket', 'Neues Ticket')
                            : tkt.activityType === 'comment' ? t('header.activityComment', 'Neuer Kommentar')
                            : tkt.activityType === 'email' ? t('header.activityEmail', 'E-Mail eingegangen')
                            : tkt.activityType === 'attachment' ? t('header.activityAttachment', 'Neuer Anhang')
                            : t('header.activityGeneric', 'Neue Aktivität')}
                        </span>
                      )}
                    </div>
                  )}
                  footerRow={(
                    <div className="kopf-ticket-fuss">
                      {tkt.isAssignedToMe ? t('header.assignedToYou', 'Dir zugewiesen') : (tkt.isUnassigned ? t('header.unassigned', 'Nicht zugewiesen') : (tkt.assignedTo || ''))}
                    </div>
                  )}
                />
              ))}
            </div>
          );
        })()}
      </div>
    )}
  </div>
);

export default Glocke;
